import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Badge from "@/v2-backoffice-client/components/badge"
import Button from "@/v2-backoffice-client/components/button"
import UptimeConfigPlatformDeleteButton from "@/v2-backoffice-client/uptime/configPlatform/delete/UptimeConfigPlatformDeleteButton"
import type { UptimeConfigQuery } from "@/v2-backoffice-client/uptime/config/__types__/uptime.config.query"

type Platform = UptimeConfigQuery["getStatusConfig"]["Platforms"][number]

export type UptimeConfigPlatformRowProps = ComponentProps<"li"> & {
  platform: Platform
  onEdit(): void
}

// UptimeConfigPlatformRow renders one platform row inside the
// platforms list. Disabled platforms render with a muted style so
// the operator can spot a hidden card at a glance.
function UptimeConfigPlatformRow(props: UptimeConfigPlatformRowProps) {
  const { platform, onEdit, className, ...liProps } = props

  return (
    <li
      className={cn(
        "uptime-config-row",
        !platform.IsEnabled && "uptime-config-row-disabled",
        className,
      )}
      {...liProps}
    >
      <div className="uptime-config-row-meta">
        <div className="uptime-config-row-title">
          <span>{platform.Name}</span>
          {!platform.IsEnabled && (
            <Badge variant="neutral" size="sm">
              Disabled
            </Badge>
          )}
        </div>
        <div className="uptime-config-row-subtitle">
          <code className="uptime-config-row-id">{platform.Id}</code>
          <span className="uptime-config-row-priority">
            Priority {platform.Priority}
          </span>
        </div>
      </div>

      <div className="uptime-config-row-actions">
        <Button variant="ghost" size="sm" iconSrc="pencil" onClick={onEdit}>
          Edit
        </Button>
        <UptimeConfigPlatformDeleteButton platformId={platform.Id} />
      </div>
    </li>
  )
}

export default UptimeConfigPlatformRow
